import * as React from 'react';

import Feature from 'components/Feature';
import NavigationWrapper from 'components/Navigation';
import NavigationList from 'components/NavigationList';
import AccountNavigation from 'user/components/AccountNavigation';
import './styles/AppSidebarLayout.scss';

type Props = {
  children?: React.ReactNode;
};

export default function AppSidebarLayout(props: Props) {
  return (
    <div className="AppSidebarLayout">
      <div className="AppSidebarLayout-inner">
        <div className="AppSidebarLayout-heightSetter">
          <div className="AppSidebarLayout-contentWrap">
            <div className="AppSidebarLayout-sidebar">
              <AccountNavigation data-test="new-account-nav" />
              <Feature
                name="org-flex.web.dec-21"
                on={<NavigationWrapper />}
                off={<NavigationList data-test="new-nav-list" />}
              />
            </div>
            <div className="AppSidebarLayout-content">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
